// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__Q73Qs","mainContent":"App_mainContent__mD5IX","pageContainer":"App_pageContainer__H23-Q","footer":"App_footer__aawhi"};